import { render, staticRenderFns } from "./product-view.vue?vue&type=template&id=fb9b8dbe&scoped=true&"
import script from "./product-view.vue?vue&type=script&lang=js&"
export * from "./product-view.vue?vue&type=script&lang=js&"
import style0 from "./product-view.vue?vue&type=style&index=0&id=fb9b8dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9b8dbe",
  null
  
)

export default component.exports